import { ReactNode, forwardRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { useClientHasRendered } from '../../../../helpers/hooks';
import { PostsViewerSpinner } from './PostsViewerSpinner/PostsViewerSpinner';
import { NavigationBar } from '../NavigationBar/NavigationBar';

interface PostsViewerSectionProps {
  children: ReactNode;
  id?: string;
  className?: string;
  isLoading?: boolean;
  navigationLocationName?: string;
  onBackButtonClick?: () => void;
}
// eslint-disable-next-line react/display-name
export const PostsViewerSection = forwardRef<HTMLDivElement, PostsViewerSectionProps>(
  (PostsViewerSectionProps, ref) => {
    const { children, className, isLoading, navigationLocationName, id } = PostsViewerSectionProps;
    const { onBackButtonClick: handleBackButtonClick = () => {} } = PostsViewerSectionProps;
    const clientHasRendered = useClientHasRendered();

    return (
      <div
        id={id}
        className={twMerge(
          'bg-sea-foam flex h-full w-full flex-col overflow-hidden rounded-[inherit]',
          className,
        )}
        ref={ref}
      >
        {navigationLocationName && (
          <NavigationBar
            className="z-high!"
            locationName={navigationLocationName}
            onClick={handleBackButtonClick}
          />
        )}
        {!clientHasRendered || isLoading ? <PostsViewerSpinner /> : children}
      </div>
    );
  },
);
